import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import './Footer.css';

const Footer = ({ onOpenAuthModal }) => {
  return (
    <footer className="jmi-footer">
      <div className="jmi-container">
        {/* Main Footer Links Columns */}
        <div className="footer-columns-grid">
          {/* Brand Column */}
          <div className="footer-col brand-col">
            <Link to="/" className="footer-brand-logo">
              <svg 
                viewBox="65 146 370 165" 
                className="footer-logo-img" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="none" stroke="#B52B2E" strokeWidth="6" strokeLinecap="butt">
                  <path d="M98,156 V247 A15,15 0 0 1 83,262 H74"/>
                  <path d="M110,156 V247 A27,27 0 0 1 83,274 H74"/>
                  <path d="M122,156 V247 A39,39 0 0 1 83,286 H74"/>
                  <path d="M134,156 V247 A51,51 0 0 1 83,298 H74"/>
                </g>
                <g fill="#B52B2E">
                  <polygon points="187,296 187,156 193.3,156 247.15,259 240.85,259 193,167.48 193,296"/>
                  <polygon points="329,296 329,156 322.7,156 268.85,259 275.15,259 323,167.48 323,296"/>
                  <polygon points="201,156 207.3,156 261.15,259 254.85,259"/>
                  <polygon points="215,156 221.3,156 275.15,259 268.85,259"/>
                  <polygon points="308.7,156 315,156 271.15,239.88 268,233.85"/>
                  <polygon points="294.7,156 301,156 264.15,226.49 261,220.46"/>
                  <polygon points="199,296 199,188.52 205,199.99 205,296"/>
                  <polygon points="317,296 317,188.52 311,199.99 311,296"/>
                  <polygon points="211,296 211,211.47 217,222.95 217,296"/>
                  <polygon points="305,296 305,211.47 299,222.95 299,296"/>
                  <polygon points="223,296 223,234.42 229,245.9 229,296"/>
                  <polygon points="293,296 293,234.42 287,245.9 287,296"/>
                  <rect x="380" y="156" width="6" height="140"/>
                  <rect x="392" y="156" width="6" height="140"/>
                  <rect x="404" y="156" width="6" height="140"/>
                  <rect x="416" y="156" width="6" height="140"/>
                </g>
              </svg>
             </Link>
            <div className="company-legal-name">7RAYS GLOBAL PRIVATE LIMITED</div>
            <div className="company-cin-tag" style={{ fontSize: '0.78rem', color: 'var(--gold-400)', fontFamily: 'var(--font-mono)', marginTop: '4px' }}>
              CIN: U47733GJ2026PTC171774
            </div>
            <div className="company-address-tag" style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: '2px' }}>
              Surat, Gujarat, 395010 - India.
            </div>
            <p className="footer-tagline">
              The digital network for B2B jewellery trade connecting verified buyers, sellers and operators across India.
            </p>
            <SocialLinks variant="footer" />
          </div>

          {/* PLATFORM Column */}
          <div className="footer-col">
            <h4 className="footer-col-title">PLATFORM</h4>
            <ul className="footer-nav-list">
              <li><Link to="/apply">Apply for Access</Link></li>
              <li><Link to="/buyer">Buyer Portal</Link></li>
              <li><Link to="/seller">Seller Portal</Link></li>
              <li><Link to="/operator">Operator Hub Portal</Link></li>
              <li><Link to="/how-it-works">How JMI Works</Link></li>
              <li><Link to="/categories">Wholesale Catalogues</Link></li>
              <li><Link to="/blog">Industry Journal & Rates</Link></li>
            </ul>
          </div>

          {/* BUSINESS Column */}
          <div className="footer-col">
            <h4 className="footer-col-title">BUSINESS & EDITORIAL</h4>
            <ul className="footer-nav-list">
              <li><Link to="/about">About JMI</Link></li>
              <li><Link to="/apply">Onboarding Application</Link></li>
              <li><Link to="/blog">Market Intelligence Reports</Link></li>
              <li><Link to="/blog-portal/login">Author Publishing Studio</Link></li>
              <li><Link to="/contact">Partner With Us</Link></li>
              <li><Link to="/contact">Bullion Refining Partners</Link></li>
            </ul>
          </div>

          {/* SUPPORT Column */}
          <div className="footer-col">
            <h4 className="footer-col-title">SUPPORT</h4>
            <ul className="footer-nav-list">
              <li><Link to="/contact">Help Center & Hotline</Link></li>
              <li><Link to="/contact">Contact Operating Desk</Link></li>
              <li><Link to="/faq">Trade & Custody FAQs</Link></li>
              <li><Link to="/buyer-account-delete">Buyer Account Deletion</Link></li>
              <li><Link to="/seller-account-delete">Seller Account Deletion</Link></li>
            </ul>
          </div>

          {/* LEGAL Column */}
          <div className="footer-col">
            <h4 className="footer-col-title">LEGAL</h4>
            <ul className="footer-nav-list">
              <li><Link to="/terms">Terms of Trade</Link></li>
              <li><Link to="/privacy">Privacy Overview</Link></li>
              <li><Link to="/buyerprivacy">Buyer Privacy Policy</Link></li>
              <li><Link to="/sellerprivacy">Seller Privacy Policy</Link></li>
              <li><Link to="/terms">Refund & Cancellation</Link></li>
            </ul>
          </div>

          {/* DOWNLOAD Column */}
          <div className="footer-col">
            <h4 className="footer-col-title">DOWNLOAD</h4>
            <div className="footer-download-badges">
              {/* Buyer App */}
              <a
                href="https://play.google.com/store/apps/details?id=com.jmi.jmi"
                target="_blank"
                rel="noopener noreferrer"
                className="google-play-pill"
                aria-label="Download JMI Buyer App on Google Play"
              >
                <svg className="play-store-icon" viewBox="0 0 466 511.98" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <g fillRule="nonzero">
                    <path fill="#EA4335" d="M199.9 237.8 1.4 470.17c7.22 24.57 30.16 41.81 55.8 41.81 11.16 0 20.93-2.79 29.3-8.37l244.16-139.46L199.9 237.8z"/>
                    <path fill="#FBBC04" d="m433.91 205.1-104.65-60-111.61 110.22 113.01 108.83 104.64-58.6c18.14-9.77 30.7-29.3 30.7-50.23-1.4-20.93-13.95-40.46-32.09-50.22z"/>
                    <path fill="#34A853" d="M199.42 273.45 329.27 145.1 87.9 8.37C79.53 2.79 68.36 0 57.2 0 30.7 0 6.98 18.14 1.4 41.86l198.02 231.59z"/>
                    <path fill="#4285F4" d="M1.39 41.86C0 46.04 0 51.63 0 57.2v397.64c0 5.57 0 9.76 1.4 15.34l216.27-214.86L1.39 41.86z"/>
                  </g>
                </svg>
                <div className="pill-text">
                  <span className="pill-sub">GET IT ON</span>
                  <span className="pill-main">Google Play</span>
                </div>
                <span className="pill-app-label">Buyer App</span>
              </a>

              {/* Seller App */}
              <a
                href="https://play.google.com/store/apps/details?id=com.jmi.jmiseller"
                target="_blank"
                rel="noopener noreferrer"
                className="google-play-pill"
                aria-label="Download JMI Seller App on Google Play"
              >
                <svg className="play-store-icon" viewBox="0 0 466 511.98" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <g fillRule="nonzero">
                    <path fill="#EA4335" d="M199.9 237.8 1.4 470.17c7.22 24.57 30.16 41.81 55.8 41.81 11.16 0 20.93-2.79 29.3-8.37l244.16-139.46L199.9 237.8z"/>
                    <path fill="#FBBC04" d="m433.91 205.1-104.65-60-111.61 110.22 113.01 108.83 104.64-58.6c18.14-9.77 30.7-29.3 30.7-50.23-1.4-20.93-13.95-40.46-32.09-50.22z"/>
                    <path fill="#34A853" d="M199.42 273.45 329.27 145.1 87.9 8.37C79.53 2.79 68.36 0 57.2 0 30.7 0 6.98 18.14 1.4 41.86l198.02 231.59z"/>
                    <path fill="#4285F4" d="M1.39 41.86C0 46.04 0 51.63 0 57.2v397.64c0 5.57 0 9.76 1.4 15.34l216.27-214.86L1.39 41.86z"/>
                  </g>
                </svg>
                <div className="pill-text">
                  <span className="pill-sub">GET IT ON</span>
                  <span className="pill-main">Google Play</span>
                </div>
                <span className="pill-app-label">Seller App</span>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="footer-bottom-bar">
          <div className="copyright-text">
            © 2026 JMI • 7RAYS GLOBAL PRIVATE LIMITED (CIN: U47733GJ2026PTC171774) Surat, Gujarat, 395010 - India. All rights reserved.
          </div>
          <div className="footer-disclaimer-snippet">
            India's governed B2B jewellery operating system. Strict BIS Hallmarking and GST compliance enforced.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;